// import { getProvince } from "@fetch/address";

const state = {
  dialog: false,
};

const getters = {
  getDialogStatus: state => state.dialog,
};

const actions = {
  toggleDialog({ commit }) {
    commit('TOGGLE_DIALOG');
  },
};

const mutations = {
  TOGGLE_DIALOG: state => (state.dialog = !state.dialog),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
